import CallService from "../../service/call";

const Action = {
    FETCH_HISTORY: '[callRecord] FETCH HISTORY',
    FETCH_INCOMING: '[callRecord] FETCH INCOMING',
    FETCH_ARCHIVE_BY_ID: '[callRecord] FETCH ARCHIVE BY ID',
};

const ActionCreator = {
    fetchHistory() {
        return async dispatch => {
            const list = await CallService.history();
            dispatch({type: Action.FETCH_HISTORY, payload: list});
            return list;
        };
    },
    fetchIncoming() {
        return async dispatch => {
            const list = await CallService.incoming();
            dispatch({type: Action.FETCH_INCOMING, payload: list});
            return list;
        };
    },
    fetchArchiveById({ archiveId }) {
        return async dispatch => {
            const archive = await CallService.fetchArchiveById({ archiveId })
            dispatch({ type: Action.FETCH_ARCHIVE_BY_ID, payload: archive })
            return archive
        }
    }
};

export default {Action, ActionCreator};



// WEBPACK FOOTER //
// ./src/store/actionreducers/callRecord.js